import ComplexTable from 'components/table';
import { createColumnHelper } from '@tanstack/react-table';

import Button from 'components/button';
import UseApi from 'hooks/useApi';
import { IFilter } from 'types';
import { encodeFilters } from 'utils';

type RowObj = {
  code: string;
  discount: string;
  expirationDate: string;
};

const columnHelper = createColumnHelper<RowObj>();
const filters: IFilter[] = [
  { key: 'code', type: 'text', label: 'Code' },
  { key: 'discount', type: 'number', label: 'Discount' },
  {
    key: 'showArchived',
    type: 'select',
    options: ['false', 'true'],
    label: 'Archived',
  },
];

const CouponsTable = () => {
  const { getApi, patchApi } = UseApi();

  async function fetchData(
    options: any,
    filterState: { [key: string]: string },
  ) {
    const { pageIndex, pageSize } = options;
    const response = await getApi(
      `coupons?page=${pageIndex + 1}&limit=${pageSize}${encodeFilters(
        filterState,
      )}`,
    );
    const data = response.data.data.coupons;
    const pageCount = response.data.data.totalPages;
    return {
      rows: data,
      pageCount,
    };
  }
  const archiveCoupon = async (id: string) => {
    await patchApi(`coupons/${id}/metadata`, {
      isArchived: true,
      archivedOn: new Date(),
    });
  };
  const columns = [
    columnHelper.accessor('code', {
      id: 'code',
      header: () => <p className="  ">CODE</p>,
      cell: (info) => <p className="  ">{info.getValue()}</p>,
    }),

    columnHelper.accessor('discount', {
      id: 'discount',
      header: () => <p className="  ">DISCOUNT AMOUNT (PKR)</p>,
      cell: (info) => <p className="  ">{info.getValue()}</p>,
    }),

    columnHelper.accessor('expirationDate', {
      id: 'expirationDate',
      header: () => <p className="  ">EXPIRATION DATE</p>,
      cell: (info) => (
        <p className="  ">{info.getValue()?.substring(0, 10) || '-'}</p>
      ),
    }),
    {
      id: 'archive',
      header: () => <p className="  "></p>,
      cell: (info: any) => (
        <Button
          extraClasses="text-sm font-bold text-navy-700 dark:text-white"
          onClick={() => archiveCoupon(info.row.original._id)}
          variant="error"
        >
          Archive
        </Button>
      ),
    },
  ];

  return (
    <div>
      <ComplexTable
        columns={columns}
        fetchData={fetchData}
        header="Coupons Table"
        filters={filters}
      />
    </div>
  );
};
export default CouponsTable;

// const deleteCoupon = async (id: string) => {
//   await deleteApi(`coupons/${id}`);
// };
// {
//   id: "delete",
//   header: () => (
//     <p className="text-sm font-bold text-gray-600 dark:text-white"></p>
//   ),
//   cell: (info: any) => (
//     <Button
//       extraClasses="text-sm font-bold text-navy-700 dark:text-white"
//       onClick={() => deleteCoupon(info.row.original._id)}
//     >
//       Delete
//     </Button>
//   ),
// },
